import { render, staticRenderFns } from "./scenicVideoList.vue?vue&type=template&id=19f4bcb6&scoped=true&"
import script from "./scenicVideoList.vue?vue&type=script&lang=js&"
export * from "./scenicVideoList.vue?vue&type=script&lang=js&"
import style0 from "./scenicVideoList.vue?vue&type=style&index=0&id=19f4bcb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4bcb6",
  null
  
)

export default component.exports